export default {
  send: "发送|创建|启动",
  save: "保存待发",
  edit: "修改",
  pause: "暂停",
  resume: "恢复",
  repeal: "撤销",
  terminate: "终止",
  remark: "备注",
  submit: "提交会签|提交",
  addadvise: "添加会签人",
  signature: "签收",
  dispatch: "转派",
  goto: "跳转",
  return: "退回",
  recall: "撤回",
  rollback: "回退",
  transmit: "转发",
  addMpders: "添加会签人员"
};
